"use client"

import { createContext, useContext, useState, useCallback, type ReactNode } from "react"

interface UploadDocumentContextValue {
  isOpen: boolean
  selectedDealId: string | null
  droppedFiles: File[]
  openDialog: (dealId?: string) => void
  closeDialog: () => void
  setDroppedFiles: (files: File[]) => void
  clearFiles: () => void
}

const UploadDocumentContext = createContext<UploadDocumentContextValue | null>(null)

export function UploadDocumentProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false)
  const [selectedDealId, setSelectedDealId] = useState<string | null>(null)
  const [droppedFiles, setDroppedFilesState] = useState<File[]>([])

  const openDialog = useCallback((dealId?: string) => {
    if (dealId) setSelectedDealId(dealId)
    setIsOpen(true)
  }, [])

  const closeDialog = useCallback(() => {
    setIsOpen(false)
    setSelectedDealId(null)
    setDroppedFilesState([])
  }, [])

  const setDroppedFiles = useCallback((files: File[]) => {
    setDroppedFilesState(files)
    setIsOpen(true)
  }, [])

  const clearFiles = useCallback(() => {
    setDroppedFilesState([])
  }, [])

  return (
    <UploadDocumentContext.Provider
      value={{
        isOpen,
        selectedDealId,
        droppedFiles,
        openDialog,
        closeDialog,
        setDroppedFiles,
        clearFiles,
      }}
    >
      {children}
    </UploadDocumentContext.Provider>
  )
}

export function useUploadDocument() {
  const context = useContext(UploadDocumentContext)
  if (!context) {
    throw new Error("useUploadDocument must be used within UploadDocumentProvider")
  }
  return context
}








